import Card from "components/card";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Loading from "components/loading/Loading";
import axiosClient from "axios-client.js";
import { activationStates } from "variables/activations";
import { ACTIVATION_TYPES, SOURCE_TYPES } from "utils/constants";

const ConfirmActivation = () => {
    const { code } = useParams();
    const location = useLocation();

    const [load, setLoad] = useState(false);
    const [message, setMessage] = useState({});
    const [state, setState] = useState(null);

    const source = state?.data?.source;

    useEffect(() => {
        setLoad(true);
        setMessage({});
        axiosClient
            .get("/activation/" + code)
            .then(({ data }) => {
                setLoad(false);
                setState(data);
            })
            .catch((err) => {
                const response = err.response;
                setLoad(false);
                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    }, []);

    return (
        <div>
            {load ? <Loading /> : null}
            <div className="mt-5 grid h-full grid-cols-1 gap-5">
                <Card
                    extra={
                        "w-full h-full p-4 sm:overflow-x-auto flex justify-center"
                    }
                >
                    {message.hasOwnProperty("text") ? (
                        <div
                            className={
                                "mb-6 text-left text-base " +
                                (message.type === "SUCCESS"
                                    ? "text-green-500"
                                    : message.type === "ERROR"
                                    ? "text-red-500"
                                    : message.type === "WARNING"
                                    ? "text-amber-500"
                                    : null)
                            }
                        >
                            <p>{message.text}</p>
                        </div>
                    ) : state ? (
                        location.state.type === ACTIVATION_TYPES.ONSITE ? (
                            <div className="flex flex-wrap items-center justify-center py-20 text-center">
                                <div className="mb-6 w-full">
                                    <img
                                        src="/icon/file-check.svg"
                                        alt="Attivazione completata"
                                        className="mx-auto mb-4 w-10 p-0"
                                    />
                                </div>
                                {location.state.status ===
                                    activationStates.PENDING_COMPLETION &&
                                state.status ===
                                    activationStates.PENDING_CONFIRMATION ? (
                                    <>
                                        <div className="mb-6 w-full">
                                            <span className="text-2xl font-bold text-gray-800 dark:text-white">
                                                Richiesta attivazione licenza{" "}
                                            </span>
                                            <span className="text-2xl font-bold text-blue-900 dark:text-white">
                                                #{state.code}
                                            </span>
                                            <span className="text-2xl font-bold text-gray-800 dark:text-white">
                                                <br />
                                                completata con successo
                                            </span>
                                        </div>
                                        <div className="w-full">
                                            <span className="text-xl font-medium text-gray-800 dark:text-white">
                                                La sua richiesta è in attesa di
                                                approvazione e appena verrà
                                                approvato la macchina si
                                                attiverà e riceverete una
                                                notifica.
                                            </span>
                                        </div>
                                    </>
                                ) : location.state.status ===
                                      activationStates.PENDING_COMPLETION &&
                                  state.status ===
                                      activationStates.WAITING_FOR_SERVER_CODE ? (
                                    <>
                                        <div className="mb-6 w-full">
                                            <span className="text-2xl font-bold text-gray-800 dark:text-white">
                                                Richiesta attivazione licenza{" "}
                                            </span>
                                            <span className="text-2xl font-bold text-blue-900 dark:text-white">
                                                #{state.code}
                                            </span>
                                            <span className="text-2xl font-bold text-gray-800 dark:text-white">
                                                <br />
                                                inviata con successo
                                            </span>
                                        </div>
                                        <div className="w-full">
                                            <p className="text-xl font-medium text-gray-800 dark:text-white">
                                                La tua richiesta è in attesa di
                                                approvazione. <br />
                                                Per completare l’attivazione
                                                della macchina, sarà necessario
                                                inserire i dati del server.
                                            </p>
                                        </div>
                                    </>
                                ) : location.state.status ===
                                      activationStates.WAITING_FOR_SERVER_CODE &&
                                  (state.status ===
                                      activationStates.PENDING_CONFIRMATION ||
                                      state.status ===
                                          activationStates.COMPLETED) ? (
                                    <>
                                        <div className="mb-6 w-full">
                                            <span className="text-2xl font-bold text-gray-800 dark:text-white">
                                                Richiesta attivazione licenza{" "}
                                            </span>
                                            <span className="text-2xl font-bold text-blue-900 dark:text-white">
                                                #{state.code}
                                            </span>
                                            <span className="text-2xl font-bold text-gray-800 dark:text-white">
                                                <br />
                                                completata con successo
                                            </span>
                                        </div>
                                        <div className="w-full">
                                            <span className="text-xl font-medium text-gray-800 dark:text-white">
                                                Grazie per aver completato la
                                                richiesta. L’aggiornamento è in
                                                corso e riceverete una notifica
                                                al suo termine.
                                            </span>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="mb-6 w-full">
                                            <span className="text-2xl font-bold text-gray-800 dark:text-white">
                                                Richiesta attivazione licenza{" "}
                                            </span>
                                            <span className="text-2xl font-bold text-blue-900 dark:text-white">
                                                #{state.code}
                                            </span>
                                            <span className="text-2xl font-bold text-gray-800 dark:text-white">
                                                <br />
                                                completata con successo
                                            </span>
                                        </div>
                                        <div className="w-full">
                                            <span className="text-xl font-medium text-gray-800 dark:text-white">
                                                {source ===
                                                SOURCE_TYPES.RESELLER
                                                    ? "Riceverai conferma di presa in carico."
                                                    : "Riceverai conferma dell’approvazione."}
                                            </span>
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : location.state.type === ACTIVATION_TYPES.CLOUD ? (
                            <div className="flex flex-wrap items-center justify-center py-20 text-center">
                                <div className="mb-6 w-full">
                                    <img
                                        src="/icon/file-check.svg"
                                        alt="Attivazione completata"
                                        className="mx-auto mb-4 w-10 p-0"
                                    />
                                </div>
                                <div className="mb-6 w-full">
                                    <span className="text-2xl font-bold text-gray-800 dark:text-white">
                                        Richiesta attivazione licenza{" "}
                                    </span>
                                    <span className="text-2xl font-bold text-blue-900 dark:text-white">
                                        #{state.code}
                                    </span>
                                    <span className="text-2xl font-bold text-gray-800 dark:text-white">
                                        <br />
                                        completata con successo
                                    </span>
                                </div>
                                <div className="w-full">
                                    <span className="text-xl font-medium text-gray-800 dark:text-white">
                                        {source === SOURCE_TYPES.RESELLER
                                            ? "La sua richiesta è stata inoltrata al reparto delivery per la sua attivazione. Sarà cura del reparto delivery comunicarvi le credenziali d'accesso appena sarà completata l'attivazione."
                                            : " La sua richiesta è in attesa di approvazione, appena verrà approvato provvederemo a inoltrare la richiesta al reparto delivery per la sua attivazione. Sarà cura del reparto delivery comunicarvi le credenziali d'accesso appena sarà completata l'attivazione."}
                                    </span>
                                </div>
                            </div>
                        ) : null
                    ) : null}
                </Card>
            </div>
        </div>
    );
};

export default ConfirmActivation;
